f    <template>
    <div>
        <Header/>


        <!--Start Rev Slider Wrapper-->
        <section class="rev_slider_wrapper">
            <div id="slider1" class="rev_slider"  data-version="5.0">
                <ul>
                    <li data-transition="fade">
                        <img v-if="this.slide1image" :src="this.serverurl+'/public/sliders/'+this.slide1image"  alt="" width="1920" height="695" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="1">
                        <div class="tp-caption tp-resizeme"
                             data-x="right" data-hoffset="0"
                             data-y="center" data-voffset="0"
                             data-transform_idle="o:1;"
                             data-transform_in="x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0.01;s:3000;e:Power3.easeOut;"
                             data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                             data-mask_in="x:[100%];y:0;s:inherit;e:inherit;"
                             data-splitin="none"
                             data-splitout="none"
                             data-start="500">
                            <div  class="slide-content-box">
                                <h1 v-html="$i18n.locale == 'en' ? slidetitle1en:slidetitle1ar">  {{ $i18n.locale == 'en' ? slidetitle1en :  slidetitle1ar
                                                    }}</h1>
                                <h3 v-html="$i18n.locale == 'en' ? slidesubtitle1en:slidesubtitle1ar">شفافية السوق و التنفيذ الفوري</h3>
                                <div class="buttons" style="text-align:center">
                                    <a   class="hvr-sweep-to-bottom" href="account.html">فتح حساب حقيقي</a>
                                    <a class="black-bg hvr-sweep-to-bottom" href="account.html">فتح حساب تجريبي</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li data-transition="slidedown">
                        <img v-if="this.slide2image" :src="this.serverurl+'/public/sliders/'+this.slide2image"  alt=""  width="1920" height="695" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" datfa-bgparallax="2">
                        <div class="tp-caption tp-resizeme"
                             data-x="left" data-hoffset="0"
                             data-y="center" data-voffset="0"
                             data-transform_idle="o:1;"
                             data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;"
                             data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                             data-splitin="none"
                             data-splitout="none"
                             data-responsive_offset="on"
                             data-start="1000">
                            <div class="slide-content-box">
                                <h1 v-html="$i18n.locale == 'en' ? slidetitle2en:slidetitle2ar">  {{ $i18n.locale == 'en' ? slidetitle2en :  slidetitle2ar
                                                    }}</h1>
                                <h3 v-html="$i18n.locale == 'en' ? slidesubtitle2en:slidesubtitle2ar">{{
                                    $i18n.locale == 'en' ? slidesubtitle2en:slidesubtitle2ar }}</h3>
                                <div class="buttons" style="text-align:center">
                                    <a class="hvr-sweep-to-bottom" href="account.html">فتح حساب حقيقي</a>
                                    <a class="black-bg hvr-sweep-to-bottom" href="account.html">فتح حساب تجريبي</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li data-transition="fade">
                        <img v-if="this.slide3image" :src="this.serverurl+'/public/sliders/'+this.slide3image"  alt="" width="1920" height="695" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="1">
                        <div class="tp-caption tp-resizeme"
                             data-x="right" data-hoffset="0"
                             data-y="center" data-voffset="0"
                             data-transform_idle="o:1;"
                             data-transform_in="x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0.01;s:3000;e:Power3.easeOut;"
                             data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                             data-mask_in="x:[100%];y:0;s:inherit;e:inherit;"
                             data-splitin="none"
                             data-splitout="none"
                             data-start="500">
                            <div class="slide-content-box">
<h1 v-html="$i18n.locale == 'en' ? slidetitle3en:slidetitle3ar">  {{ $i18n.locale == 'en' ? slidetitle3en :  slidetitle3ar
                                                    }}</h1>                                 <h3 v-html="$i18n.locale == 'en' ? slidesubtitle3en:slidesubtitle3ar">{{
                                    $i18n.locale == 'en' ? slidesubtitle3en:slidesubtitle3ar }}</h3>
                                <div class="buttons" style="text-align:center">
                                    <a class="hvr-sweep-to-bottom" href="account.html">فتح حساب حقيقي</a>
                                    <a class="black-bg hvr-sweep-to-bottom" href="account.html">فتح حساب تجريبي</a>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </section>
        <!--End Rev Slider Wrapper-->

        <!--Start call to action area-->
        <section class="call-to-action-area">
            <div class="container">
                <div class="title pull-center" style="text-align: center">
                    <h1 style="color: #FFFFFF">
                      {{$i18n.locale == 'en' ?  taglineen:taglinear}}</h1>

                </div> </div>
        </section>
        <!--End call to action area-->

        <!--Start welcome area-->
        <section class="welcome-area">
            <div class="container" v-if="homepageblocks">
                
                <div class="row" v-html="$i18n.locale == 'en' ?  homepageblocks[0].contenten: homepageblocks[0].contentar"> 
                   {{ $i18n.locale == 'en' ?  homepageblocks[0].contenten: homepageblocks[0].contentar  }}
                   </div>
                    
            </div>
        </section>
        <!--End welcome area-->

        <!--Start Statistic area-->
        <section class="statistic-area">
            <div class="container" v-if="homepageblocks">
                    <!--Start single statistic item-->
                 <div class="row" v-html="$i18n.locale == 'en' ?  homepageblocks[1].contenten: homepageblocks[1].contentar" > 
                   {{ $i18n.locale == 'en' ?  homepageblocks[1].contenten: homepageblocks[1].contentar  }} </div>
                    
                
            </div>
        </section>
        <!--End Statistic area-->

        <!--Start fact counter area-->
        <section class="fact-counter-area">
            <div class="container" v-if="homepageblocks">
                <div class="row" v-html="$i18n.locale == 'en' ?  homepageblocks[2].contenten: homepageblocks[2].contentar">
                     {{ $i18n.locale == 'en' ?  homepageblocks[2].contenten: homepageblocks[2].contentar  }}
                </div>
            </div>
        </section>
        <!--End fact counter area-->

        <!--Start Industry Expertise area-->
        <section class="industry-expertise-area" v-if="homepageblocks">
            <div  class="row"  v-html="$i18n.locale == 'en' ?  homepageblocks[3].contenten: homepageblocks[3].contentar">
                                {{ $i18n.locale == 'en' ?  homepageblocks[3].contenten: homepageblocks[3].contentar  }}
            </div>
        </section>
        <!--End Industry Expertise area-->
        <!--Start caption area-->
        <section class="caption-area">
            <div class="container" v-if="homepageblocks">
                <div class="row" v-html="$i18n.locale == 'en' ?  homepageblocks[5].contenten: homepageblocks[5].contentar">
                   {{ $i18n.locale == 'en' ?  homepageblocks[5].contenten: homepageblocks[5].contentar  }}
                </div>
            </div>
        </section>
        <!--Start caption area-->
        <!--Start how work and faq area-->
<section class="how-work-and-faq-area">
    <div class="container">
        <div class="row">
            <div v-if="homepageblocks" class="col-lg-6 col-md-12 col-sm-12 col-xs-12" v-html="$i18n.locale == 'en' ?  homepageblocks[6].contenten: homepageblocks[6].contentar">
               <div class="how-we-work-content" >
                                    {{$i18n.locale == 'en' ?  homepageblocks[6].contenten: homepageblocks[6].contentar}}

                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="faq-content">
                    <div class="accordion-box">
                        <!--Start single accordion box-->
                        <div class="accordion accordion-block" >
                            <div class="accord-btn" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'"><h4  v-html="$i18n.locale == 'en' ?  faq1.questionen: faq1.questionar" :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" >{{ $i18n.locale == 'en' ?  faq1.questionen: faq1.questionar}}</h4></div>
                            <div class="accord-content"  :style="$i18n.locale == 'en' ?  'text-align: left!important': 'text-align: right'">
                                <p :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" v-html="$i18n.locale == 'en' ?  faq1.answeren: faq1.answerar">{{$i18n.locale == 'en' ?  faq1.answeren: faq1.answerar}}/p>
                            </div>
                        </div>
                        <!--End single accordion box-->
                        <!--Start single accordion box-->
                        <div class="accordion accordion-block">
                            <div class="accord-btn" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" ><h4 v-html="$i18n.locale == 'en' ?  faq2.questionen: faq2.questionar" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'"  :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'">{{ $i18n.locale == 'en' ?  faq2.questionen: faq2.questionar}}</h4></div>
                          <div class="accord-content"  :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'">
                                <p :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" v-html="$i18n.locale == 'en' ?  faq2.answeren: faq2.answerar">{{$i18n.locale == 'en' ?  faq2.answeren: faq2.answerar}}/p>
                            </div>
                            </div>
                        
                        <!--End single accordion box-->
                        <!--Start single accordion box-->
 <div class="accordion accordion-block">
                            <div class="accord-btn" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" ><h4 v-html="$i18n.locale == 'en' ?  faq3.questionen: faq3.questionar" :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" >{{ $i18n.locale == 'en' ?  faq3.questionen: faq3.questionar}}</h4></div>
                          <div class="accord-content"  :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'">
                                <p :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" v-html="$i18n.locale == 'en' ?  faq3.answeren: faq3.answerar">{{$i18n.locale == 'en' ?  faq3.answeren: faq3.answerar}}/p>
                            </div>
                            </div>
                                            <!--End single accordion box-->
                        <!--Start single accordion box-->
 <div class="accordion accordion-block">
                            <div class="accord-btn" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" ><h4 v-html="$i18n.locale == 'en' ?  faq4.questionen: faq4.questionar" :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'" >{{ $i18n.locale == 'en' ?  faq4.questionen: faq4.questionar}}</h4></div>
                          <div class="accord-content"  :style="$i18n.locale == 'en' ?  'text-align: left!important;padding-left:5%!important;': 'text-align: right'">
                                <p :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" v-html="$i18n.locale == 'en' ?  faq4.answeren: faq4.answerar">{{$i18n.locale == 'en' ?  faq4.answeren: faq4.answerar}}/p>
                            </div>
                            </div>
                        </div>                        <!--End single accordion box-->
                    </div>
                </div>
            </div>
        </div>
    

</section>        <!--End how we work and faq area-->

        <!--Start testimonial carousel area-->
        <!--End testimonial carousel area-->

        <!--Start latest news area-->
        <!--End latest news area-->
        <!--Start Brand area-->
        <section class="brand-area">
           <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brand">
                    <!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login">
                            <img v-if="fundinglist"  :src="fundinglist[0].photo" alt="Awesome Brand Image"/>
                            </a>
                    </div>
                    <!--End single brand item-->
                    <!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[1].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
                    <!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[2].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
                    <!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[3].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
                    <!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[4].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
					<!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[0].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
					<!--Start single brand item-->
                    <div class="single-brand-item">
                        <a href="https://portal.marketequityinc.com/Login"> <img v-if="fundinglist"  :src="fundinglist[5].photo" alt="Awesome Brand Image"/></a>
                    </div>
                    <!--End single brand item-->
                </div>
            </div>
        </div>
    </div>
        </section>
        <!--End Brand area-->


        <Footer/>
    </div>

</template>

<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar', '中文', 'Français'],
            sliders: [],
            slidericons: [],
            sliderbuttons: [],
            slidetitle1en: null,
            slidetitle1ar: null,
            slidetitle2en: null,
            slidetitle2ar: null,
            slidetitle3en: null,
            slidetitle3ar: null,
            slidericonsactive: [],
            sliderbuttonsactive: [],
            
            slidesubtitle1en: null,
            slidesubtitle1ar: null,
            slidesubtitle2en: null,
            slidesubtitle2ar: null,
            slidesubtitle3en: null,
            slidesubtitle3ar: null,
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            funding:'',
            faq1:'',
            faq2:'',
            faq3:'',
            faq4:'',
            taglineen:'',
            taglinear:'',
            
           



        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
       // this.loadhomesliderdata();

this.loadfunding();  
                this.loadfaq();       
    },
    mounted() {
        this.loadhomesliderdata();
        this.loadhomepageblocks();
        this.loadceomessage();
        this.loadsuccessstories();
        this.loadsocialmedia();
        this.loaddata();
        this.loadfunding();  
                this.loadfaq();       

    },
    created(){
                this.loadfunding();  
                this.loadfaq();       


    },

    methods: {
loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.taglineen = res.data.sitesettings[0].taglineen;
                        this.taglinear = res.data.sitesettings[0].taglinear;
                       

                    }
                });
        },
        loadhomesliderdata() {

            this.$axios.get("loadhomesliderdata",
            )
                .then(res => {
                    if (res) {

                        this.sliders = res.data.sliders;
                        this.slidetitle1en = res.data.sliders[0].en_title;
                        this.slidetitle1ar = res.data.sliders[0].ar_title;
                        
                        this.slidesubtitle1en = res.data.sliders[0].en_subtitle;
                        this.slidesubtitle1ar = res.data.sliders[0].ar_subtitle;
                        
                        this.slidetitle2en = res.data.sliders[1].en_title;
                        this.slidetitle2ar = res.data.sliders[1].ar_title;
                        
                        this.slidesubtitle2en = res.data.sliders[1].en_subtitle;
                        this.slidesubtitle2ar = res.data.sliders[1].ar_subtitle;
                        
                        this.slidetitle3en = res.data.sliders[2].en_title;
                        this.slidetitle3ar = res.data.sliders[2].ar_title;
                        
                        this.slidesubtitle3en = res.data.sliders[2].en_subtitle;
                        this.slidesubtitle3ar = res.data.sliders[2].ar_subtitle;
                       
                        this.slide1image = res.data.sliders[0].image;
                        this.slider1id = res.data.sliders[0].id;
                      
                        this.slide2image = res.data.sliders[1].image;
                        this.slider2id = res.data.sliders[1].id;
                        this.slide3image = res.data.sliders[2].image;
                        this.slider3id = res.data.sliders[2].id;


                        this.slidericons = res.data.slidericons;
                        this.slidericonsactive = this.slidericons[0];

                        this.sliderbuttons = res.data.sliderbuttons;
                        this.sliderbuttonsactive = res.data.sliderbuttons[0];


                    }
                });
        },
        
         loadfaq() {

            this.$axios.get("loadfaq",
            )
                .then(res => {
                    if (res) {

                        this.faq1 = res.data.faqdata[3];
                        this.faq2 = res.data.faqdata[7];
                        this.faq3 = res.data.faqdata[6];
                        this.faq4 = res.data.faqdata[0];



                    }
                });
        },
        loadhomepageblocks() {

            this.$axios.get("loadhomepageblocks",
            )
                .then(res => {
                    if (res) {

                        this.homepageblocks = res.data.homepageblocks;
                        this.homepageblocks2 = res.data.homepageblocks[2].id;
                        this.homeblock1 = res.data.homepageblocks[0].image;
                        this.homeblockimage1 = res.data.homepageblocks[0].image;
                        this.homepageblocksicons = res.data.blocksicons[0];
                        this.homepageblocksicons3 = this.homepageblocksicons[2];
                        this.homepageblockssecondicons = res.data.blockssecondicons[0];
                        this.blockssecondiconstitle = res.data.blockssecondiconstitle[0];
                    }
                });
        },
        loadceomessage() {

            this.$axios.get("loadceomessage",
            )
                .then(res => {
                    if (res) {

                        this.ceomessage = res.data.ceomessage[0];

                    }
                });
        },
        loadsuccessstories() {

            this.$axios.get("loadsuccessstories",
            )
                .then(res => {
                    if (res) {

                        this.successstories = res.data.successstories;

                    }
                });
        },
        loadsocialmedia() {

            this.$axios.get("loadsuccessstories",
            )
                .then(res => {
                    if (res) {

                        this.successstories = res.data.successstories;

                    }
                });
        },
        
         loadfunding() {

            this.$axios.get("loadfunding",
            )
                .then(res => {
                    if (res) {

                        this.fundinglist = res.data.fundinglist;

                    }
                });
        },


    }
}
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>


